import { motion } from 'framer-motion'
import { Save } from 'lucide-react'

export default function Settings() {
  return (
    <div className="w-full min-w-0 max-w-full">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight text-zinc-950">
          Einstellungen
        </h1>
        <p className="mt-1 text-sm text-zinc-500">Allgemeine Angaben der Website.</p>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative bg-white rounded-xl shadow-sm border border-zinc-200 p-6 space-y-6 overflow-hidden"
      >
        {/* Subtle gradient overlay */}
        
        <div className="relative z-10">
          <div>
            <h2 className="text-lg font-semibold text-zinc-950 mb-4">
              Allgemeine Einstellungen
            </h2>
            
            <div className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-zinc-600 mb-2">
                  Website-Name
                </label>
                <input
                  type="text"
                  defaultValue="Hückels May"
                  className="input-dashboard"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-zinc-600 mb-2">
                  E-Mail
                </label>
                <input
                  type="email"
                  defaultValue="info@hueckels-may.de"
                  className="input-dashboard"
                />
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-zinc-200">
            <motion.button 
              className="inline-flex h-9 items-center gap-2 rounded-md bg-zinc-900 px-3 text-sm font-medium text-white shadow-sm hover:bg-zinc-800"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Save className="h-5 w-5" />
              Speichern
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

















